import React from 'react'

export const FollowButton = ({ button=false}) =>{
    const [active] = React.useState(button)

    return (<div
        onClick={e=>{
            e.preventDefault()
        }}
        className={`button ${active ? 'following':''}`}
        ><p className={`${active ? '':'outline'}`} >
            {active ? 'Following' : 'Follow'}
        </p>
    </div>)
}